import { render, staticRenderFns } from "./view-address.vue?vue&type=template&id=d96d1c78&scoped=true"
import script from "./view-address.vue?vue&type=script&lang=js"
export * from "./view-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96d1c78",
  null
  
)

export default component.exports